import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { PRODUCTS } from './MetaPixel';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Lucas M.',
    location: 'Mendoza',
    product: 'Megapack + Potenciadores',
    text: 'Lo terminé en un fin de semana. Muy recomendable.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata',
    product: 'Megapack Barbero Pro',
    text: 'Está mucho mejor de lo que esperaba. Tiene un montón de material útil.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'VR',
    name: 'Valentín R.',
    location: 'Santa Fe',
    product: 'Megapack Barbero Pro',
    text: 'Lo compré sin muchas expectativas y me sorprendió para bien.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén',
    product: 'Megapack + Potenciadores',
    text: 'Si sos barbero y querés crecer, vale la pena. Lo volvería a comprar.',
    bg: 'bg-brandOrange'
  }];
  return <Section className="bg-bg-base" data-id="element-213" data-mp="36m0lppe8ifxb">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-214" data-mp="36kz2gxn2en4i">
        <h2 className="font-display font-normal md:text-[48px] text-txt-primary mb-3 md:mb-4 text-[36px]" data-id="element-215" data-mp="3kcvocjy540sg">
          Lo que dicen <span className="text-brandOrange" data-id="element-216" data-mp="3gcbr7gdkgx6b">los barberos</span>
        </h2>
        <div className="inline-flex items-center gap-2" data-id="element-217" data-mp="3ub344zgp0csv">
          <span className="font-sans font-medium text-brandOrange text-[15px] md:text-[16px]" data-id="element-218" data-mp="3uajx4dskz8tm">
            4.9/5
          </span>
          <span className="text-brandOrange" data-id="element-219" data-mp="1zxajc9t0515k">·</span>
          <span className="font-sans text-brandOrange text-[15px] md:text-[16px]" data-id="element-220" data-mp="1zy3jut1dauf9">
            +300 barberos en Latinoamérica ya aplican el sistema.
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-221" data-mp="3v1s3ra2rltnh">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-222" data-mp="3upbefb6xhbo" data-mpi={i}>
            <div className="bg-bg-card p-5 md:p-6 rounded-[16px] border border-brandOrange/30 h-full flex flex-col" data-id="element-223" data-mp="7v97dfk12ew8">
              <div className="flex items-center gap-3 mb-4" data-id="element-224" data-mp="cvwwtwslynoc">
                <div className={`w-12 h-12 ${t.bg} text-black rounded-full flex items-center justify-center font-sans font-bold text-sm shrink-0`} data-id="element-225" data-mp="htyfigm4gkza">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-226" data-mp="rkt2xob3tqmb">
                  <p className="font-sans font-bold text-txt-primary text-[15px] md:text-[16px] leading-tight mb-1" data-id="element-227" data-mp="rlupoq1hg1jv">
                    {t.name}
                  </p>
                  <p className="text-[13px] font-sans text-txt-muted" data-id="element-228" data-mp="10lr7c7pgg05f">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-primary font-quote italic text-[16px] md:text-[18px] leading-[1.6] mb-5" data-id="element-229" data-mp="1fnzhg1r1xfgl">
                "{t.text}"
              </p>
              <div className="mt-auto" data-id="element-230" data-mp="1aqg1mxepgumj">
                <span className="inline-block bg-bg-highlight text-txt-muted font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[11px] px-2.5 py-1 rounded" data-id="element-231" data-mp="15oqptfjnscxe">
                  {t.product}
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-card border-2 border-success" data-id="element-232" data-mp="1th773nvko0vn">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-233" data-mp="1omtji7n5iy1j">
        <div className="py-8 md:py-10" data-id="element-234" data-mp="1kmstdpqowyen">
          <ShieldCheck size={80} className="mx-auto text-success mb-6 relative z-10" data-id="element-235" data-mp="1klrjvppbojz1" />
          <h2 className="font-display font-normal text-[36px] md:text-[52px] leading-[1.1] text-txt-primary mb-6 relative z-10" data-id="element-236" data-mp="2h5qg65mg4hos">
            GARANTÍA 15 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[16px] md:text-[18px] leading-[1.6] md:leading-[1.7] text-txt-primary opacity-80 space-y-2 mb-8 relative z-10" data-id="element-237" data-mp="1wu4gj90oh25u">
            <p data-id="element-238" data-mp="1nvizxjernx7p">Abrís los niveles. Los usás en tu negocio.</p>
            <p data-id="element-239" data-mp="1nx3vnccthm75">Si en 15 días no es lo que esperabas:</p>
            <p data-id="element-240" data-mp="1rxnquadtyfqn">devolución del 100%.</p>
            <p data-id="element-241" data-mp="1ryp2oh2o769f">Sin formularios. Sin drama. Sin vueltas.</p>
          </div>
          <p className="font-sans text-[15px] md:text-[16px] text-brandOrange relative z-10" data-id="element-242" data-mp="2fni0kj2uro6o">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como barbero?',
    a: 'Sí. El Nivel 1 empieza desde la mentalidad y la identidad. No importa si tenés 3 meses o 3 años. El sistema funciona para quien recién arranca y para quien quiere escalar lo que ya tiene.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'El acceso llega a tu email en menos de 5 minutos después del pago. Descargás los PDFs directamente. Sin aplicaciones, sin claves, sin esperas. Todo en tu celular o computadora desde el primer momento.'
  }, {
    q: '¿Necesito invertir mucho en publicidad para que funcione?',
    a: 'No. El sistema está diseñado para funcionar con $1 USD por día en Meta Ads. El Nivel 3 explica exactamente cómo configurar la campaña de mensajes con presupuesto mínimo y resultado máximo.'
  }, {
    q: '¿Funciona si no tengo muchos seguidores en Instagram?',
    a: 'Completamente. El sistema no depende de seguidores ni de Reels virales. Depende de anuncios pagos locales que llegan directamente a hombres del barrio. El Bono 6 además enseña cómo crecer en Instagram sin depender del algoritmo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 15 días de garantía total. Si abrís el material y no es lo que esperabas, escribís a soportecentershop95@gmail.com y te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Los Potenciadores se pueden usar junto al Megapack?',
    a: 'Sí, están diseñados para usarse en paralelo. El Megapack resuelve el problema base de llenar la agenda. Los Potenciadores agregan las capas de upselling, Google Maps, finanzas, video y sistema de equipo que llevan la barbería al siguiente nivel.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-base" data-id="element-243" data-mp="1dmscxme9ketc">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-244" data-mp="1inq3am9fgf5x">
        <h2 className="font-display font-normal text-[36px] md:text-[52px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-245" data-mp="1iohnz21hkshf">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-246" data-mp="1sektg1psnywn">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-brandOrange/30 rounded-[12px] overflow-hidden transition-colors`} data-id="element-247" data-mp="uz6um5mgu0db" data-mpi={i}>
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-248" data-mp="3d7hyk3awwqrg">
                <span className="font-sans font-bold text-[15px] md:text-[17px] text-txt-primary" data-id="element-249" data-mp="346abkhdujcco">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandOrange shrink-0" size={20} data-id="element-250" data-mp="2u9fgk8gs7u35" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-251" data-mp="2phnlbkmol06o" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[15px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-primary opacity-80 border-t border-line pt-4" data-id="element-252" data-mp="2lehjcp6lpv60">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: 'Miércoles y jueves con la silla vacía',
    costo: 'Ingresos perdidos cada semana'
  }, {
    sin: 'Anuncios sin sistema que no convierten',
    costo: 'Plata gastada en publicidad que no funciona'
  }, {
    sin: 'WhatsApp sin guion, clientes que se enfrían',
    costo: 'Turnos que se pierden en la conversación'
  }, {
    sin: 'Sin upselling: cobrás siempre lo mismo',
    costo: 'Ticket estancado aunque trabajes más'
  }, {
    sin: 'Agenda reactiva: llena el viernes, vacía el martes',
    costo: 'Stress y facturación impredecible'
  }, {
    sin: 'Domingo buscando qué publicar',
    costo: 'El mismo ciclo, el mismo año'
  }];
  return <Section className="bg-bg-card" data-id="element-253" data-mp="37ltnvouwe4yr">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-254" data-mp="2sq5hbt23x5rp">
        <h2 className="font-display font-normal md:text-[52px] text-center mb-8 md:mb-12 text-txt-primary text-[36px]" data-id="element-255" data-mp="2srff0h51sbxt">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="mb-10 md:mb-12" data-id="element-256" data-mp="2e500tpkwbhqs">
          <div className="grid grid-cols-2 gap-4 md:gap-8 mb-6 px-4" data-id="element-257" data-mp="2e5ru2tr0t3dw">
            <div className="font-sans font-bold text-[15px] md:text-[16px] text-danger" data-id="element-258" data-mp="2a3xy2yrrsnk2">
              Sin el Megapack
            </div>
            <div className="font-sans font-bold text-[15px] md:text-[16px] text-brandOrange" data-id="element-259" data-mp="2j31flybaguwg">
              Costo real
            </div>
          </div>
          <div className="space-y-4 md:space-y-5 px-4" data-id="element-260" data-mp="2x1hx8kaow5td">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 md:gap-8 items-center" data-id="element-261" data-mp="2t0fw1xx7pjor" data-mpi={i}>
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.4] md:leading-[1.5] text-txt-primary opacity-80" data-id="element-262" data-mp="36uqc7qv585j7">
                  {row.sin}
                </div>
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.4] md:leading-[1.5] text-txt-primary flex items-start gap-2" data-id="element-263" data-mp="3grbhmdb2rink">
                  <span className="text-brandOrange" data-id="element-264" data-mp="3dxh1kgdh3pdf">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-bg-base border-l-4 border-brandOrange p-6 md:p-8" data-id="element-265" data-mp="395h3yukvl8k0">
          <p className="font-sans font-bold text-[16px] md:text-[18px] text-txt-primary mb-2" data-id="element-266" data-mp="348z2q4or7scf">
            El próximo lunes puede ser diferente...
          </p>
          <p className="font-sans text-[15px] md:text-[17px] text-txt-primary opacity-80 mb-4" data-id="element-267" data-mp="qytkm7gpgx8">
            Podés seguir publicando reels que no convierten o entrar al mundo
            digitál y tener tu barbería llena.
          </p>
          <p className="font-sans font-bold text-[16px] md:text-[18px] text-brandOrange" data-id="element-268" data-mp="3nuvjyliyio8d">
            Vos decidís.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
const FinalCTAOffers = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  return <div className="max-w-xl mx-auto flex flex-col gap-5 md:gap-6 mb-10 md:mb-12" data-id="element-269" data-mp="27hf2csdobozo">
      {/* Basic option */}
      <div role="button" tabIndex={0} onClick={() => setSelected('basic')} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setSelected('basic');
      }
    }} aria-pressed={selected === 'basic'} className={`relative rounded-[16px] md:rounded-[20px] p-5 md:p-7 border-2 cursor-pointer transition-all bg-bg-card text-left ${selected === 'basic' ? 'border-brandOrange shadow-[0_0_40px_rgba(240,188,76,0.25)]' : 'border-line opacity-90'}`} data-id="element-270" data-mp="n0p2ft91lvgj">
        <div className="flex items-center gap-2.5 mb-2" data-id="element-271" data-mp="1fokz4xym3ndb">
          <span className="text-[22px] md:text-[26px] leading-none" data-id="element-272" data-mp="1fp31mcbvaxto">📘</span>
          <h4 className="font-sans font-extrabold uppercase tracking-[0.5px] text-txt-primary text-[18px] md:text-[22px] leading-[1.1]" data-id="element-273" data-mp="1jolnpbffdey3">
            MEGAPACK FUNCIONAL 365
          </h4>
        </div>

        <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 mb-4 md:mb-5" data-id="element-274" data-mp="3li1dy77lorsj">
          6 Tomos + 6 Bonos · 365 sesiones
        </p>

        <p className="font-sans text-[15px] md:text-[18px] line-through text-danger leading-tight mb-1" data-id="element-275" data-mp="nnybqwza10o3">
          $34.990
        </p>
        <p className={`font-display font-black text-[40px] md:text-[52px] leading-none mb-4 md:mb-5 transition-colors ${selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-276" data-mp="11oiz86g4zknx">
          $17.990
        </p>

        <CTAButton href={PRODUCTS.basic.checkoutUrl} fullWidth trackingProduct="basic" onClick={e => e.stopPropagation()} className={selected === 'basic' ? '!py-4 !text-[15px] md:!text-[17px]' : '!bg-transparent !text-txt-primary !border !border-line !shadow-none hover:!bg-bg-highlight !animate-none !py-4 !text-[15px] md:!text-[17px]'} data-id="element-277" data-mp="1bjkk2q3dq0kp">
          QUIERO EL MEGAPACK
        </CTAButton>
      </div>

      {/* Plus option — with MÁS ELEGIDO pill */}
      <div className="relative pt-3" data-id="element-278" data-mp="2905bxwzqt4g7">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] px-4 py-1 rounded-full whitespace-nowrap z-10 shadow-md" data-id="element-279" data-mp="28x0zydg1d4ez">
          ⭐ MÁS ELEGIDO
        </div>

        <div role="button" tabIndex={0} onClick={() => setSelected('plus')} onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelected('plus');
        }
      }} aria-pressed={selected === 'plus'} className={`relative rounded-[16px] md:rounded-[20px] p-5 md:p-7 border-2 cursor-pointer transition-all bg-bg-card text-left ${selected === 'plus' ? 'border-brandOrange shadow-[0_0_40px_rgba(240,188,76,0.25)]' : 'border-line opacity-90'}`} data-id="element-280" data-mp="23yfy69l4ycof">
          <div className="flex items-center gap-2.5 mb-2" data-id="element-281" data-mp="1c7jmvdeq4g39">
            <span className="text-[22px] md:text-[26px] leading-none" data-id="element-282" data-mp="147vp24gvfx4e">🏆</span>
            <h4 className="font-sans font-extrabold uppercase tracking-[0.5px] text-txt-primary text-[18px] md:text-[22px] leading-[1.1]" data-id="element-283" data-mp="149zqmfrask1i">
              MEGAPACK + POTENCIADORES
            </h4>
          </div>

          <p className="font-sans text-[14px] md:text-[16px] text-txt-primary opacity-80 mb-4 md:mb-5" data-id="element-284" data-mp="ufppa8kdoben">
            6 Tomos + 6 Bonos + 6 Potenciadores
          </p>

          <p className="font-sans text-[15px] md:text-[18px] line-through text-danger leading-tight mb-1" data-id="element-285" data-mp="liytzydnh0l4">
            $49.990
          </p>
          <p className={`font-display font-black text-[40px] md:text-[52px] leading-none mb-4 md:mb-5 transition-colors ${selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'}`} data-id="element-286" data-mp="bj8284gh4zoq">
            $24.990
          </p>

          <CTAButton href={PRODUCTS.plus.checkoutUrl} fullWidth trackingProduct="plus" onClick={e => e.stopPropagation()} className={selected === 'plus' ? '!py-4 !text-[15px] md:!text-[17px]' : '!bg-transparent !text-txt-primary !border !border-line !shadow-none hover:!bg-bg-highlight !animate-none !py-4 !text-[15px] md:!text-[17px]'} data-id="element-287" data-mp="25vxw4m6ue8w4">
            QUIERO EL SISTEMA COMPLETO
          </CTAButton>
        </div>
      </div>
    </div>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-base border-t-2 border-brandOrange pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-288" data-mp="35szh1f2td5fn">
      <FadeIn className="max-w-[800px] mx-auto text-center" data-id="element-289" data-mp="39ul2vpxbsu1z">
        <div className="mb-10 md:mb-12" data-id="element-290" data-mp="39x7atqo4pbkq">
          <div className="inline-flex items-center gap-1.5 bg-danger/15 border border-danger/40 text-danger font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-291" data-mp="3eupaeqg9aeg2">
            <span className="w-1.5 h-1.5 rounded-full bg-danger animate-pulse" data-id="element-292" data-mp="u2nee2hmcmbd"></span>
            🚨 ÚLTIMA OPORTUNIDAD
          </div>
          <h3 className="font-display font-normal text-[36px] md:text-[44px] text-txt-primary mb-4" data-id="element-293" data-mp="2q8xw30p3gaip">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="flex justify-center gap-3 md:gap-5 text-brandOrange mb-4" data-id="element-294" data-mp="3047wxl3rabuw">
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-295" data-mp="2v5wo9dp767e9">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-296" data-mp="27gvbxfd8uc3p">
                {hours.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-297" data-mp="2h7ggrkjigcv2">
                hs
              </span>
            </div>
            <div className="font-display font-normal text-[40px] md:text-[72px] py-1 flex items-center" data-id="element-298" data-mp="1opug307f6wod">
              :
            </div>
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-299" data-mp="1jq822ojrpcei">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-300" data-mp="3vcjpwrqgidh3">
                {minutes.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-301" data-mp="3mfj3urqv0rgt">
                min
              </span>
            </div>
            <div className="font-display font-normal text-[40px] md:text-[72px] py-1 flex items-center" data-id="element-302" data-mp="i0j9p1ubomqj">
              :
            </div>
            <div className="bg-bg-card w-[70px] h-[80px] md:w-[90px] md:h-[100px] flex flex-col items-center justify-center rounded-[12px]" data-id="element-303" data-mp="mwgpn71obr2s">
              <span className="font-display font-normal text-[40px] md:text-[72px] leading-none" data-id="element-304" data-mp="dxd4lxiy51ln">
                {seconds.toString().padStart(2, '0')}
              </span>
              <span className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1" data-id="element-305" data-mp="2yo3wgkk87jyp">
                seg
              </span>
            </div>
          </div>
          <p className="font-sans text-[14px] md:text-[15px] text-txt-primary opacity-70" data-id="element-306" data-mp="3pc2tj5mzf7nj">
            Después sube. No vuelve a este precio.
          </p>
        </div>

        <FinalCTAOffers data-id="element-307" data-mp="3geadfz9frvz3" />

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[13px] md:text-[14px] text-txt-primary opacity-80" data-id="element-308" data-mp="3gflgtxyyz1po">
          <span className="flex items-center gap-2" data-id="element-309" data-mp="cxaatdyb0diq">
            <Lock size={16} data-id="element-310" data-mp="cvza5n05nlvu" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-311" data-mp="7yqm55sbsnmo">
            <Clock size={16} data-id="element-312" data-mp="801s9c98u7gy" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-313" data-mp="35ecq2w7wnei">
            <ShieldCheck size={16} data-id="element-314" data-mp="3uds64ppurtdq" /> Garantía 15 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-315" data-mp="3ubfqij7khv3u">
            <CreditCard size={16} data-id="element-316" data-mp="voky7l4tm85v" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-brandOrange/30 py-12 px-6" data-id="element-317" data-mp="y8zr4j2u0udz">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-318" data-mp="135zmo0222equ">
        <div data-id="element-319" data-mp="138m20lv6tyjm">
          <h2 className="font-display font-normal text-[28px] text-brandOrange mb-1" data-id="element-320" data-mp="1865gnmvssdc3">
            ✂️ MEGAPACK BARBERO PRO™
          </h2>
          <p className="font-sans font-medium text-[14px] text-txt-primary opacity-60" data-id="element-321" data-mp="1d5qiq669l1t1">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[14px] text-txt-primary opacity-60 max-w-md mx-auto" data-id="element-322" data-mp="1m5na4fk1gers">
          El sistema de publicidad y captación número 1 para barberos en
          Latinoamérica. Porque llenar la agenda no debería depender de que te
          vuelvas influencer.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[14px] text-txt-primary opacity-70 pt-4" data-id="element-323" data-mp="1vxay26hdzdoi">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-brandOrange transition-colors" data-id="element-324" data-mp="24x6cck68nosr">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-brandOrange transition-colors" data-id="element-325" data-mp="39c4mhtt8kd8m">
            📲 @centershop.digital
          </a>
          <a href="#" className="hover:text-brandOrange transition-colors" data-id="element-326" data-mp="3e94tq81tnm1b">
            🌐 www.centershop.store
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-327" data-mp="3nbdzylq24t8w">
          <p className="font-sans text-[12px] text-[#888888]" data-id="element-328" data-mp="3n909yra8i787">
            © 2025 Center Shop Digital. Todos los derechos reservados.
          </p>
          <p className="space-x-4 font-sans text-[12px] text-[#888888]" data-id="element-329" data-mp="v9tr765k989">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-330" data-mp="5umpyiiwysni">
              Términos y condiciones
            </a>
            <span data-id="element-331" data-mp="9wzmcgbrte7m">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-332" data-mp="9xswlr9xului">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};